/**
 * Header used to select which of a user's accessible organizations is the
 * "active org" for a request — i.e. whose data the user is viewing.
 */
export const AuActiveOrgHeader = 'x-au-active-org';
